<template>
  <div class="alert">
    <div class="alert__header">
      <h2>ATTENTION:</h2>
      <p>
        To View or Edit the pricing sheet for this project, please open on a desktop device
      </p>
    </div>
    <div class="alert__body">
      <button class="btn btn--blue">Close</button>
    </div>
  </div>
</template>
<script>
export default {
  name: "PricingPageAlert"
}
</script>
<style scoped lang="scss">
@import "../../../styles/components/_pricingpage.scss";
</style>